import RestauranteCardapioItem from "./RestauranteCardapioItem";
import GrupoBebida from "./GrupoBebida";

export default class RestauranteCardapioBebidaItem extends RestauranteCardapioItem {

    grupo?: GrupoBebida;

}